import styled from "styled-components";

export const CalendarTarif = styled.div`
.react-calendar {
  width: 100%;
  max-width: 100%;
  background: white;
  font-family: Arial, Helvetica, sans-serif;
  line-height: 1.125em;
}

.react-calendar--doubleView {
  width: 700px;
}

.react-calendar--doubleView .react-calendar__viewContainer {
  display: flex;
  margin: -0.5em;
}

.react-calendar--doubleView .react-calendar__viewContainer > * {
  width: 50%;
  margin: 0.5em;
}

.react-calendar,
.react-calendar *,
.react-calendar *:before,
.react-calendar *:after {
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.react-calendar button {
  margin: 0;
  border: 0;
  outline: none;
}
.react-calendar__navigation button {
  font-size: 24px;
  font-weight: 700;
},
.react-calendar__month-view__weekdays__weekday{
  font-size: 16px;
}

.react-calendar__month-view__days button, .react-calendar__month-view__weekdays__weekday {
  border : 1px solid white;
}

.react-calendar button:enabled:hover:not(.calendar-cell-disabled) {
  cursor: pointer;
}

.react-calendar__navigation {
  display: flex;
  height: 44px;
  margin-bottom: 1em;
}

.react-calendar__navigation button {
  min-width: 44px;
  background: none;
}

.react-calendar__navigation button:disabled {
  background-color: #f0f0f0;
}

.react-calendar__navigation button:enabled:hover,
.react-calendar__navigation button:enabled:focus {
  background-color: #e6e6e6;
}

.react-calendar__month-view__weekdays {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0.75em;
}

.react-calendar__month-view__weekdays__weekday {
  padding: 0.5em;
}

.react-calendar__month-view__weekNumbers .react-calendar__tile {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75em;
  font-weight: bold;
}


.react-calendar__month-view__days__day--neighboringMonth {
  color: #757575;
}

.react-calendar__year-view .react-calendar__tile,
.react-calendar__decade-view .react-calendar__tile,
.react-calendar__century-view .react-calendar__tile {
  padding: 2em 0.5em;
}

.react-calendar__tile {
  max-width: 100%;
  padding: 10px 6.6667px;
  background: none;
  text-align: center;
  line-height: 16px;
  border-radius: 5px;
}

.react-calendar__tile:disabled {
  background-color: #f0f0f0;
}

.react-calendar__tile:enabled:hover:not(.calendar-cell-disabled1),
.react-calendar__tile:enabled:focus:not(.calendar-cell-disabled1) {
  background-color: #e6e6e6;
}


.react-calendar__tile--hasActive {
  background: #76baff;
}

.react-calendar__tile--hasActive:enabled:hover,
.react-calendar__tile--hasActive:enabled:focus {
  background: #a9d4ff;
}

.react-calendar--selectRange .react-calendar__tile--hover {
  background-color: #e6e6e6;
}

.react-calendar__tile p {
  display: block;
  max-width: 98%;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
  /* background-color: #ce9dff; */
  padding-left: 2%;
  border-radius: 5px;
}

.calendar-cell-disabled{
  background-color: #ebd8ff;
}


.calendar-legende-icon {
  width: 16px;
  height: 10px;
  border-radius: 5px;
  display: block;
  margin-right: 3px;
  position: relative;
  top: 2px;
}

.calendar-legende-ligne {
  display: flex;
  margin-bottom: 0.5em;
}

.calendar-content {
  margin-bottom: 0.2em;
  cursor: pointer;
}

.calendar-legende-container {
  margin-top: 3.3%;
  display: flex;
  flex-flow: row wrap;
  gap: 2%;
}

.react-calendar button:enabled:hover:not(.calendar-cell-disabled) {
  cursor: default;
}


.react-calendar__navigation .react-calendar__navigation__label {
  pointer-events: none !important;
}
.react-calendar__navigation .react-calendar__navigation__label::first-letter{
  text-transform: uppercase;
}

.calendar-content-prix {
  margin-bottom: 0.2em;
  cursor: pointer;
  color:  green;
  font-weight: 600;
}

.custom__container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  margin: 10px 0;
  padding: 10px;
}

.custom__container > * > * {
  margin: 10px;
}
.react-calendar__tile > abbr {
 /* font-size:16px*/
}



.custom__container__content {
  display: flex;
  max-width: 100%;
  flex-basis: 420px;
  flex-direction: column;
  flex-grow: 100;
  align-items: stretch;
  padding-top: 1em;
}

.custom__container__content .react-calendar {
  margin: 0 auto;
}
.react-calendar__month-view__days {
  min-height: 430px !important;
  min-width: 850px !important;
}
`;

export default CalendarTarif;